module.exports = __webpack_public_path__ + "img/Button_Plus.b6164132.png";